const STORAGE_KEY = 'formCreateReturnTo'

/**
 * Persist where form create should return after the wizard finishes.
 * @param {string} returnTo
 */
export function setFormCreateReturnTo(returnTo) {
    if (!returnTo) return
    try {
        sessionStorage.setItem(STORAGE_KEY, returnTo)
    } catch (e) {
        // sessionStorage may be unavailable
    }
}

/**
 * Read and clear the return URL for a form create flow.
 * @returns {string|null}
 */
export function consumeFormCreateReturnTo() {
    try {
        const returnTo = sessionStorage.getItem(STORAGE_KEY)
        if (returnTo) sessionStorage.removeItem(STORAGE_KEY)
        return returnTo
    } catch (e) {
        return null
    }
}
